import React from 'react';
import { login } from '../services/auth';
import role from '../services/ui/role';
import navigator from '../services/ui/navigator';
import {
    INSPECTION_LISTING,
    PLATFORM_ADMIN_HOME,
} from '../constants/routeDestinations';
import { sessionUserUpdated } from './session';
import {
    ACCOUNT_DEACTIVATED,
    ACCOUNT_NOT_CONFIRMED,
    GENERIC_ERROR,
    INVALID_CREDENTIALS,
    INVALID_RHE_SSO_ID,
} from '../constants/authErrorCodes';

export const errorCodeReasons = {
    [INVALID_CREDENTIALS]: 'The email or password you entered is incorrect.',
    [ACCOUNT_NOT_CONFIRMED]: 'Your account has not been confirmed yet.',
    [ACCOUNT_DEACTIVATED]: (
        <span>
            Your organisation does not have an active subscription to The
            Housing App, please contact{' '}
            <a href="mailto:support@rheglobal.com">support@rheglobal.com</a> for
            more information.
        </span>
    ),
    [GENERIC_ERROR]:
        'We had a problem trying to log you in, please try again later.',
    [INVALID_RHE_SSO_ID]:
        'There was a problem logging into your SSO account. Please contact support.',
};

export const signIn =
    (credentials, setStatus, redirect = null) =>
    async (dispatch) => {
        let sessionUser;
        try {
            sessionUser = await login(credentials);
            dispatch(sessionUserUpdated(sessionUser));

            if (redirect) {
                navigator.push(redirect);
            } else if (role.isPlatformAdmin(sessionUser)) {
                navigator.push(PLATFORM_ADMIN_HOME);
            } else {
                navigator.push(INSPECTION_LISTING);
            }
        } catch ({ response }) {
            if (response.data.error_code === 'two_factor_auth_required') {
                window.location = response.data.url;
            } else if (response.status === 401) {
                setStatus({
                    errorMessage: errorCodeReasons[response.data.error_code],
                    fieldErrors: {},
                    errors: [],
                });
            } else if (response.status === 422) {
                setStatus({
                    errorMessage: response.data.message,
                    fieldErrors: response.data.errors,
                    errors: [
                        ...Object.keys(response.data.errors).map((key) => ({
                            input: key,
                            message: response.data.errors[key],
                        })),
                    ],
                });
            }
            throw response;
        }

        return sessionUser;
    };
